module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/administrators-d77a8e207f34cf09840a46e0e3f5ced9.svg";